export const rolesTypes = {
    FETCH_REQUEST: "ROLES_FETCH_REQUEST",
    FETCH_SUCCESS: "ROLES_FETCH_SUCCESS",
    FETCH_FAILURE: "ROLES_FETCH_FAILURE",
    DOWNLOAD_REQUEST: "ROLES_DOWNLOAD_REQUEST",
    DOWNLOAD_SUCCESS: "ROLES_DOWNLOAD_SUCCESS",
    DOWNLOAD_FAILURE: "ROLES_DOWNLOAD_FAILURE",
    SET_CURRENT_MODAL: 'SET_CURRENT_MODAL',
};

export const setCurrentModal = (data) => ({
    type: rolesTypes.SET_CURRENT_MODAL,
    payload: data,
});

export const fetchRequest = (filter) => ({
    type: rolesTypes.FETCH_REQUEST,
    payload: filter
});

export const fetchSuccess = (resp) => ({
    type: rolesTypes.FETCH_SUCCESS,
    payload: resp
});
export const fetchFailure = (resp) => ({
    type: rolesTypes.FETCH_FAILURE,
    payload: resp
});

export const downloadRequest = () => ({
    type: rolesTypes.DOWNLOAD_REQUEST,
});

export const downloadSuccess = (resp) => ({
    type: rolesTypes.DOWNLOAD_SUCCESS,
    payload: resp
});

export const downloadFailure = (error) => ({
    type: rolesTypes.DOWNLOAD_FAILURE,
    payload: error
});